import "../scss/codeEntry.scss";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Code = {};


    function setCodeValidation() {
        $(document).on("submit", "#code form", function (e) {
            var form = $(this);
            form.find("input[type=submit]").prop("disabled", true);
            // prevent the user from hitting ENTER on a field to submit again
            form.find("input").prop("readonly", true);
            document.body.style.cursor = "wait";
        });
    }

    function checkReturnType() {
        const status = $("#ReturnType").val();
        const returnURL = $("#ReturnUrl").val();
        const tmpTarget = "#find-school-overlay";
        const findSchoolModalTitle = $("#find-school-overlay-title").val();
        const $form = $("#code #form0");

        switch (status) {
            case "CampaignParticipant":
                window.location.href = returnURL;
                break;
            case "Organization":
                M2.Modal.create('find-school-overlay', findSchoolModalTitle, returnURL, 'modal-md');
                $form.find("input[type=submit]").prop("disabled", false);
                $form.find("input").prop("readonly", false);
                document.body.style.cursor = "default";
                break;
            default:
                $form.find("input[type=submit]").prop("disabled", false);
                $form.find("input").prop("readonly", false);
                document.body.style.cursor = "default";
                break;
        }
    }

    function setSearchParticipantTools() {
        $(document).on('click', '.support-choice', function (e) {

            var $choice = $(this);
            var $radioButton = $choice.find('input[type=radio]');

            $('.support-choice').removeClass('active');
            $choice.addClass('active');
            $radioButton.prop("checked", true);
            enableSubmit($('.find-school-results-overlay input[type=submit]'));

            var isParticipant = $choice.hasClass('support-participant') ? true : false;
            if (!isParticipant) {
                $('.support-participant input[type=text]').val('');
            }
        });
    }

    function enableSubmit($btn) {
        $btn.removeClass('disabled').attr('disabled', false);
    }

    function disableSubmit($btn) {
        $btn.addClass('disabled').attr('disabled', true);
    }

    M2.Code = {
        init: function () {
            setCodeValidation();
            setSearchParticipantTools();
            checkReturnType();
        },
        onSuccess: function () {
            checkReturnType();
            $.validator.unobtrusive.parse($("#code"));
        },
        nameOnSuccess: function () {
            $.validator.unobtrusive.parse($("#name"));
            const status = $("#ReturnType").val();
            const returnURL = $("#ReturnUrl").val();
            switch (status) {
                case "Success":
                    parent.window.location.href = returnURL;
                    break;
                default:
                    // Do nothing
                    break;
            }
        }
    }
})(jQuery);

$(function () {
    M2.Code.init();
});